<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
    <div class="bmjl-search">
      <el-date-picker
        v-model="bmsj"
        type="date"
        placeholder="选择报名日期"
        style="width: 180px;margin-right: 10px;margin-bottom: 10px;">
      </el-date-picker>
      <el-input v-model="xueyuanMc" clearable placeholder="请输入学生姓名" style="width: 180px;margin-right: 10px;margin-bottom: 10px;"></el-input>
      <el-button @click="searchBmjl" style="margin-right: 10px;margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
    </div>
    <div class="bmjl-table">
      <el-table	:data="tableData" border :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column type="index" align="center" width="80" label="序号">
        </el-table-column>
        <el-table-column align="center" width="170" label="报名时间">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.bmsj),'yyyy-MM-dd hh:mm')}}
          </template>
        </el-table-column>
        <el-table-column prop="xueyuanBm" label="学生编号">
        </el-table-column>
        <el-table-column prop="xueyuanMc" label="学生姓名">
        </el-table-column>
        <el-table-column prop="lxdh" label="手机号">
        </el-table-column>
        <el-table-column prop="bjmc" label="报名班级">
        </el-table-column>
        <el-table-column prop="czrmc" label="操作人">
        </el-table-column>
      </el-table>
      <el-pagination
          class="page-zj"
          v-if="tableData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
      </el-pagination>

    </div>
	</div>
</template>

<script>
	export default{
		name: "bmjl",
		data() {
		  return {
        jgglId: sessionStorage.getItem("jgglId"),
        loading: false,
        tableData: [],
        page: { page: 1, size: 10, total: 0 },
        bmsj: '',//报名时间
        xueyuanMc: '',//学员名称
		  }
		},
		mounted() {
			this.findxueyuanBaomingPage();
		},
		methods: {
      searchBmjl(){
        var _this = this;
        _this.page.page = 1;
        _this.findxueyuanBaomingPage();
      },
      findxueyuanBaomingPage(){
        var _this = this;
        var params = {
          jgglId: _this.jgglId,
          bmsj: _this.bmsj == null || _this.bmsj == '' ? '' :_this.formatDate(_this.bmsj, 'yyyy-MM-dd'),
          xueyuanMc: _this.xueyuanMc,
          page: _this.page.page - 1,
          size: _this.page.size
        }
        _this.loading = true;
        _this.$post('xueyuan/XueyuanController/xueyuanBaomingPage',params).then((rep) => {
          _this.loading = false;
          if (rep.code == 1) {
            _this.tableData = rep.result.page.content;
            _this.page.total = rep.result.page.totalElements;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
				})
			},
      // 每页条数
      handleSizeChange(val) {
        this.page.size = val;
        this.findxueyuanBaomingPage();
      },
      // 当前页
      handleCurrentChange(val) {
        this.page.page = val;
        this.findxueyuanBaomingPage();
      },
		}
	}
</script>

<style lang="less" scoped>
  .bmjl-search{
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
	.bmjl-table{
		.el-table{
		}
		.page-zj{
			width: 90%;
			text-align: right;
			margin: 0 auto;
			margin-top: 20px;
		}
	}
</style>